
export function resolveMediaUrl(url: string | undefined | null): string {
  if (url == null || url === "") return "";
  const trimmed = String(url).trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  const base = (import.meta.env.VITE_BACKEND_ENDPOINT as string | undefined)?.replace(
    /\/$/,
    "",
  ) ?? "";
  if (trimmed.startsWith("/")) {
    return `${base}${trimmed}`;
  }
  return `${base}/${trimmed}`;
}
